import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signUp } from '../../services/auth/signUp';
import { toast } from 'react-hot-toast';

export function useSignup() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async (
    email: string,
    password: string,
    metadata: {
      first_name: string;
      last_name: string;
      onboarding_data?: Record<string, any>;
    }
  ) => {
    setIsLoading(true);
    try {
      const result = await signUp(email, password, metadata);
      
      if (result.error) {
        toast.error(result.error);
        return false;
      }

      if (result.existingUser) {
        toast.error('An account with this email already exists');
        setTimeout(() => navigate('/login'), 1500);
        return false;
      }

      if (result.user) {
        toast.success('Account created successfully!');
        // Add a delay before navigation to show success message
        await new Promise(resolve => setTimeout(resolve, 1500));
        navigate('/community');
        return true;
      }

      throw new Error('Failed to create account');
    } catch (error) {
      console.error('Signup error:', error);
      const message = error instanceof Error ? error.message : 'Failed to create account';
      toast.error(message);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSignup
  };
}